import { Button } from 'antd';
import classnames from 'classnames';
import React, { CSSProperties, FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import styles from './styles.module.scss';

interface TileBannerButtonProps {
  to: LinkProps['to'];
  text: string;
  style?: CSSProperties;
  marginTop?: number;
  marginRight?: number;
  onClick?: () => void;
}

const TileBannerButton: FC<TileBannerButtonProps> = ({
  to,
  text,
  style,
  marginTop = 15,
  marginRight = 0,
  onClick,
}) => (
  <Link to={to}>
    <Button
      onClick={onClick}
      type="primary"
      className={classnames(styles.controlButton, styles.outline)}
      name={text}
      style={{
        ...style,
        marginTop,
        marginRight,
      }}
    >
      {text}
    </Button>
  </Link>
);

export default TileBannerButton;
